<app-clientdetails-card></app-clientdetails-card>
<app-clientdetails-list></app-clientdetails-list>
<app-clientdetails-listsearch></app-clientdetails-listsearch>
<app-clientexpanded></app-clientexpanded>